<template>
  <div>
    <section ref="document" id="element-to-print" v-if="form">
      <b-row class="mt-2">
        <b-col cols="12" class="row p-0">
          <div class="col-8 pt-4 pb-4 description">
              <h5>{{$t('identificationcard')}}</h5>
          </div>
          <div class="text-center pt-3 col-4">
           
              <template v-if="$t('isgeo') == 1">
                  <img src="../../assets/img/ardi-logo.png" width="130" alt="ARDI">
              </template>
              <template v-else>
                  <img src="../../assets/img/logoEn1.svg" width="130" alt="ARDI">
              </template>
          </div>
        </b-col>
        <b-col cols="12" class=" row p-0 mt-3">
            <div class="col-4 description">{{$t('usernamesurname')}}</div>
          <div class="col-4 p-0 pl-1 input-value">
            {{ form.fullName }}
          </div>
          <div class="col-1 description"> {{$t('idnumber')}}</div>
          <div class="col-3 p-0 pl-1 input-value">
            {{ form.personalID }}
          </div>
        </b-col>
        <b-col cols="12" class="row p-0">
            <div class="col-4 description"> {{$t('bday')}} {{$t('birthplace')}}</div>
          <div class="col-8 p-0 pl-1 input-value">
            {{ form.dataOfBirth }}, {{ form.placeOfBirth }}
          </div>
        </b-col>
        <b-col cols="12" class="p-0">
          <div class="row p-0">
            <b-col cols="12" class=" row p-0">
                <b-col cols="2" class="description border-bottom-0 pt-2">{{$t('address')}}</b-col>
                <b-col cols="2" class="description  text-center">{{$t('registered')}}</b-col>
              <b-col cols="8" class="input-value p-0"> {{ form.address.legal }}</b-col>
              <b-col cols="2" class="description border-top-0"></b-col>
              <b-col cols="2" class="description  text-center">{{$t('actual')}}</b-col>
              <b-col cols="8" class="input-value p-0"> {{ form.address.actual }}</b-col>
            </b-col>
          </div>
        </b-col>
        <b-col cols="12" class="row p-0">
            <div class="col-4 description">
                {{$t('mobemail')}}
            </div>
          <div class="col-8 p-0 pl-1 input-value">
            {{ form.contactInfo }}
          </div>
        </b-col>
        <b-col cols="12" class="row p-0">
            <div class="col-4 description"> {{$t('mainwork')}}</div>
          <div class="col-8 p-0 pl-1 input-value">
            {{ form.activitiesAndPositionsHeld }}
          </div>
        </b-col>

        <b-col cols="12" class="row p-0">
            <div class="col-4 description"> {{$t('amountsource')}}</div>
          <b-col cols="8" class="row p-0">
            <div class="col-12 p-0 pl-1 input-value">
              {{ form.SourceOfMoney }}
            </div>
          </b-col>
        </b-col>

        <b-col cols="12" class="row p-0">
            <div class="col-4 description">{{$t('citizenshipduo')}}</div>
          <div class="col-8 p-0 pl-1 input-value">
            {{ form.citizenship }}
          </div>
        </b-col>

        <b-col cols="12" class="mt-2 mb-2 p-3 description">
          {{ $t('politicallyactivedefinition') }}
        </b-col>

        <b-col cols="12" class="row p-0 mt-2">
            <div class="col-4 description">{{$t('areyoupolitically')}}</div>
          <b-col cols="8" class="input-value m-0 p-0  text-center">
              <span v-if="form.politicallyActive">{{$t('yes')}}</span>
              <span v-else>{{$t('no')}}</span>
            <b-col class="col-12 p-0 pl-1 text-left input-value border-bottom-0" v-if="form.positionAndPeriod">
              {{ form.positionAndPeriod }}
            </b-col>
          </b-col>

        </b-col>

        <b-col cols="12  row p-0 mt-2">
            <div class="description col-4">{{$t('politicallyyfamily')}}</div>
          <div class="col-8 row p-0">
            <b-col cols="12" class="input-value text-center">
                <span v-if="form.politicallyActiveFamilyMember.isPoliticallyActiveFamilyMember">{{$t('yes')}}</span>
                <span v-else>{{$t('no')}}</span>
            </b-col>
          </div>
        </b-col>
        <b-col cols="12" class=" p-0" v-if="form.politicallyActiveFamilyMember.isPoliticallyActiveFamilyMember">
          <b-row class="p-0">
              <b-col cols="4" class="input-value d-flex p-0 pr-5">
                  <div class="p-1 description text-center ">1</div>
                  {{$t('politicalpersonname')}}
              </b-col>
            <b-col cols="8" class="p-0 pl-1 input-value">
              {{ form.politicallyActiveFamilyMember.politicallyActivePersonName }}
            </b-col>
            <b-col cols="4" class="input-value d-flex p-0 pr-5">
                <div class="p-1 description text-center ">2</div>
                {{$t('politicallyyear')}}
            </b-col>
            <b-col cols="8" class="p-0 pl-1 input-value">
              {{ form.politicallyActiveFamilyMember.politicallyActivePersonPosition }}
            </b-col>
            <b-col cols="4" class="input-value d-flex p-0 pr-5">
                <div class="p-1 description text-center ">3</div>
                {{$t('relativeconnect')}}
            </b-col>
            <b-col cols="8" class="p-0 pl-1 input-value">
              {{ form.politicallyActiveFamilyMember.kinship }}
            </b-col>

          </b-row>
        </b-col>

        <b-col cols="12  row p-0 mt-2">
            <div class="description col-4">
                {{$t('relationshipwithpoliticallyactiveperson')}}
            </div>
          <div class="col-8 row p-0">
            <b-col cols="12" class="input-value text-center">
                <span v-if="form.relationshipWithPoliticallyActivePerson.isRelationshipWithPoliticallyActivePerson">{{$t('yes')}}</span>
              <span v-else>{{$t('no')}}</span>
            </b-col>
          </div>
        </b-col>

        <b-col cols="12" class="row p-0 "
               v-if="form.relationshipWithPoliticallyActivePerson.isRelationshipWithPoliticallyActivePerson"
        ><!---->

          <b-row class="p-0 col-12">
              <b-col cols="4" class="input-value d-flex p-0 pr-5">
                  <div class="p-1 description text-center ">1</div>
                  {{$t('politicalpersonname')}}
              </b-col>
            <b-col cols="8" class="p-0 pl-1 input-value">
              {{ form.relationshipWithPoliticallyActivePerson.politicallyActivePersonName }}
            </b-col>
            <b-col cols="4" class="input-value d-flex p-0 pr-5">
                <div class="p-1 description text-center ">2</div>
                {{$t('politicallyyear')}}
            </b-col>
            <b-col cols="8" class="p-0 pl-1 input-value">
              {{ form.relationshipWithPoliticallyActivePerson.politicallyActivePersonPosition }}
            </b-col>

          </b-row>
        </b-col>


        <b-col cols="12  row p-0 mt-2" >
            <div class="description col-4">
                {{$t('politicalbusines')}}
            </div>
          <div class="col-8 row p-0">
            <b-col cols="12" class="input-value text-center">
                <span v-if="form.workWithPoliticallyActivePerson.isWorkWithPoliticallyActivePerson">{{$t('yes')}}</span>
                <span v-else>{{$t('no')}}</span>
            </b-col>
          </div>
        </b-col>
        <b-col cols="12" class="row p-0"
               v-if="form.workWithPoliticallyActivePerson.isWorkWithPoliticallyActivePerson"
        >

          <b-row class="p-0 col-12">

              <b-col cols="4" class="input-value d-flex p-0 pr-5">
                  <div class="p-1 description text-center ">1</div>
                  {{$t('organisation')}}
              </b-col>
            <b-col cols="8" class="p-0 pl-1 input-value">
              {{ form.workWithPoliticallyActivePerson.organizationName }}
            </b-col>
            <b-col cols="4" class="input-value d-flex p-0 pr-5">
              <div class="p-1 description text-center ">2</div>
              {{$t('businessrelationship')}}
            </b-col>
            <b-col cols="8" class="p-0 pl-1 input-value">
              {{ form.workWithPoliticallyActivePerson.businessRelationship }}
            </b-col>

          </b-row>


        </b-col>

        <b-col cols="12" class="row p-0 mt-2">
            <div class="col-12  description">
                {{$t('iconfirm')}}
            </div>
          <div class="col-12 p-0">
            <div class="row p-0">
                <b-col cols="4 description">{{$t('usernamesurname')}}</b-col>
              <b-col cols="8" class="p-0 pl-1 input-value">
                {{ form.fullName }}
              </b-col>
              <b-col cols="4 description">{{$t('confirmdate')}}</b-col>
              <b-col cols="8" class="p-0 pl-1 input-value">
                {{ serverDate }}
              </b-col>
            </div>

          </div>
        </b-col>


      </b-row>


    </section>
  </div>
</template>

<script>

export default {
  name: "Monitoring",
  //props: ['form'],
  data() {
    return {
      form: '',
      serverDate:''
    }
  },
  mounted() {
    this.$http.get(`/policy/getCurrentData`)
    .then((r)=>{this.form= r.data.data})
    .catch((e)=>{console.log(e)})

    this.$http.get("/policy/getdate").then((r) => {
      this.serverDate = r.data
    }).catch((e) => {
      console.log(e)
    })
  }
}
</script>

<style scoped>
@import "~bpg-nino-mtavruli";

.nino-mtavruli {
  font-family: "BPG Nino Mtavruli", sans-serif;
}

div{
  page-break-inside: avoid;
  page-break-after: avoid;
}

.submit {
  position: absolute;
  bottom: 0;
  z-index: 99999;
}

.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.main-container {
  background-color: #fafafa !important;
}

.mt-7{
  margin-top: 6.7rem !important;
}

.header-background-e {
  background-color: #eee;
}

header, h1 {
  font-size: 26px;
  color: #007960;
}

.header-background-color {
  background-color: #007960;
}

.header-background {
  background: url("../../assets/img/ardi-multi-logo.svg") no-repeat center;
  background-size: cover;
}

.container {
  background-color: #fff;
}

.policy-number-background {
  background-color: #00A788;
  color: #fff;
}

/*.popover {
    max-width: 50%;
}*/

.content-header {
  background-color: #005745;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}

.content-header-text {
  transform: translateX(50%);
}

.description-in-form {
  background-color: #007961;
  color: #fff;
  font-size: 12px;
}

.value-background {
  background-color: #fafafa !important;
  border: 1px solid #EEEEEE;
  font-size: 12px;
}

.question-border {
  border: 1px solid #EEEEEE;
  background-color: #fafafa;
}

.description {
  font-size: 9pt;
  padding: 5px 10px;
}

.value-border-top {
  border-top: 2px solid #00A788;
}

.value-border-left {
  border-left: 2px solid #00A788;
}

/*.value-text {
    transform: translateX(33%);
}*/


table {
  width: 100%;
  font-size: 12px;
}

div {
  font-size: 12px;
}

th, td {
  border: 1px solid;
  border-collapse: collapse;

}

.row {
  margin: 0;

}

input {
  /*border: 0;*/
  background-color: #fafafa;
  border: 1px solid #EEEEEE;
  padding: 0 10px;
  /*border-bottom: 1px  solid #3E4643;*/

}

input[type="text"]:focus, select:focus {
  border-color: #00A788;
  box-shadow: 0 1px 1px #007a63 inset, 0 0 1px #00A788;
  outline: 0 none;
}

.description {
  background: #007a63;
  color: #fafafa;
  border: 1px solid #7b7474;
  /*padding: 6px 0 !important;*/
}

.font-size-7pt {
  font-size: 7pt !important;
}

.address{
  padding: 5px 37px;
}

.input-value {
  border: 1px solid #7b7474;
  /*padding: 5px 10px !important;*/
  /*line-height: 24px;*/
  /*height: 46px;*/
}

.form-control {
  /* height: auto !important;
   padding: 0 !important;*/
}

.custom-select {
  height: auto !important;
  padding: 0 !important;
  background-color: #fafafa;
  border-radius: 0;
}

select > option:focus {
  background-color: #00A788;
  text-align: center;
}

.font-size-8pt {
  font-size: 8pt;
}

</style>